import { Money } from '@/components/ui/Money';
import {
  COMMON_COLUMNS,
  MONEY_NUM_FMT,
  kindLabel,
  type DrilldownColumn,
} from '../drilldown-columns-shared';

/**
 * Invoiced tile drill-down columns (owner 2026-10-28).
 *
 * The Invoiced figure is invoices PLUS approved credit notes, so its rows are
 * of two kinds. `amount` arrives SIGNED from the server (credit notes are
 * negative, ex-VAT) and is shown as sent — never re-signed here, or the rows
 * would stop reconciling with the tile. `grossAmount` is the incl.-VAT
 * document total, for reference only; it is not part of the tile figure.
 *
 * The record link sits on `number` and goes to `/invoices/:id` or
 * `/credit-notes/:id` by `kind` (see `recordPath`). An invoice that was never
 * pushed has no number, so its link falls to `title`.
 */

const kind: DrilldownColumn = {
  key: 'kind',
  label: 'Type',
  get: (row) => kindLabel(row.kind),
  filter: 'options',
};

const subject: DrilldownColumn = { ...COMMON_COLUMNS.title, label: 'Subject' };

const amountExVat: DrilldownColumn = { ...COMMON_COLUMNS.amount, label: 'Amount ex-VAT' };

const grossAmount: DrilldownColumn = {
  key: 'grossAmount',
  label: 'Gross',
  get: (row) => row.grossAmount,
  render: (row) => <Money amount={row.grossAmount} currency={row.currency} />,
  numeric: true,
  numFmt: MONEY_NUM_FMT,
  filter: 'range',
};

export const INVOICED_COLUMNS: DrilldownColumn[] = [
  kind,
  COMMON_COLUMNS.number,
  subject,
  COMMON_COLUMNS.company,
  COMMON_COLUMNS.projects,
  COMMON_COLUMNS.accountLead,
  COMMON_COLUMNS.date,
  COMMON_COLUMNS.status,
  COMMON_COLUMNS.billingRegion,
  COMMON_COLUMNS.currency,
  amountExVat,
  grossAmount,
  COMMON_COLUMNS.convertedAmount,
];
